import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import translationDE from "./locales/de/translation.json";
import translationEN from "./locales/en/translation.json";
import translationHR from "./locales/hr/translation.json";
import translationIT from "./locales/it/translation.json";
import translationRU from "./locales/ru/translation.json";
import translationSL from "./locales/sl/translation.json";
import translationSR from "./locales/sr/translation.json";

const resources = {
  EN: {
    translation: translationEN,
  },
  DE: {
    translation: translationDE,
  },
  HR: {
    translation: translationHR,
  },
  IT: {
    translation: translationIT,
  },
  RU: {
    translation: translationRU,
  },
  SL: {
    translation: translationSL,
  },
  SR: {
    translation: translationSR,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "SL",
    debug: true,
    lng: localStorage.getItem("i18nextLng") || "SL",
  });
